import React from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  NumberInput,
  ReferenceInput,
  AutocompleteInput,
  required,
} from 'react-admin';
import { FormToolbar } from '../../common/FormToolbar';

const initialValues = {
  code: '',
  customerName: '',
  mobileNo: '',
  state: '',
  address1: '',
  address2: '',
  address3: '',
  pincode: '',
  userId:0
};

export const CustomerCreate = (props: any) => (
  <React.Fragment>
    <Create title="Create Customer" {...props}>
      <SimpleForm
        warnWhenUnsavedChanges
        redirect="list"
        toolbar={<FormToolbar {...props} />}
        initialValues={initialValues}
        variant="outlined"
      >
        <TextInput source="code" label="Code" fullWidth validate={[required()]} />
        <TextInput source="customerName" label="Customer Name" fullWidth validate={[required()]} />
        {/* <ReferenceInput
          label="User"
          source="userId"
          reference="users"
          fullWidth
        >
          <AutocompleteInput optionText="userName" fullWidth resettable />
        </ReferenceInput> */}
        <TextInput source="mobileNo" label="Mobile" fullWidth />
        <TextInput source="state" label="State" fullWidth />
        <TextInput source="address1" label="Address 1" fullWidth />
        <TextInput source="address2" label="Address 2" fullWidth />
        <TextInput source="address3" label="Address 3" fullWidth />
        <TextInput source="pincode" label="Pincode" fullWidth />
      </SimpleForm>
    </Create>
  </React.Fragment>
);
